/**
 * 根据不同的来源使用不同的成功页操作
 */
export const allBtn = {
  inquiry: id => [{ // 评估保存成功页
    link: `/inquiry/submit/${id}/inquiry`,
    name: '去询价'
  }, {
    link: `/usedcar/traceDetail/${id}`,
    name: '跟进线索'
  }],
  auction: id => [{ // 车辆保存成功页
    link: `/auction/confirm/${id}`,
    name: '去拍卖'
  }, {
    link: `/inquiry/submit/${id}/auction`,
    name: '去询价'
  }, {
    link: '/auction/carmanage',
    name: '返回车辆列表'
  }]
}
